export enum CardStatus {
  ONE_MONTH = "ONE_MONTH",
  THREE_MONTH = "THREE_MONTH",
  ONE_YEAR = "ONE_YEAR",
}

export const cardStatusSelected: string[] = [...Object.values(CardStatus)];
